<template>
  <section class="section--discussion">
    <b-container class="container--wide">
      <div>
        <div class="question" v-if="discussion.question">
          <b-row>
            <b-col lg="9" offset-lg="2">
              <header class="question__header">
                <img class="question__avatar" :src="domain + discussion.avatar" alt="">
                <span class="question__username">{{ discussion.name }}</span>
              </header>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8" offset-lg="2">
              <p class="question__content" v-if="isQuestionShrinked">
                {{ discussion.question | shortContent(contentLimit) }}
              </p>
              <p class="question__content" v-else>
                {{ discussion.question }}
              </p>
            </b-col>
          </b-row>
            <footer>
              <b-row>
                <b-col lg="10" offset-lg="1" class="d-flex justify-content-end">
                  <div class="d-flex">
                  <b-button class="question__button"
                    v-if="isQuestionShrinked" @click="isQuestionShrinked = false">More</b-button>
                  </div>
                </b-col>
              </b-row>
            </footer>
        </div>
        <div class="question question--response mt-5" v-if="discussion.response">
          <b-row>
            <b-col lg="9" offset-lg="2">
              <header class="question__header">
                <img
                class="question__avatar" src="@/assets/ico-scienc.png" alt="">
                <span class="question__username">{{ discussion.scientist_signature }}</span>
              </header>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8" offset-lg="2">
              <p class="question__content" v-if="isAnswerShrinked">
                {{ discussion.response | shortContent(contentLimit) }}
              </p>
              <p class="question__content" v-else>
                {{ discussion.response }}
              </p>
            </b-col>
          </b-row>
            <footer>
              <b-row>
                <b-col lg="10" offset-lg="1" class="d-flex justify-content-end">
                  <div class="d-flex">
                    <b-btn class="question__button"
                      v-if="isAnswerShrinked" @click="isAnswerShrinked = false">More</b-btn>
                  </div>
                </b-col>
              </b-row>
            </footer>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
import filters from '@/utils/filters';

export default {
  props: ['discussion'],
  data() {
    return {
      isQuestionShrinked: false,
      isAnswerShrinked: false,
      contentLimit: 0,
      domain: process.env.SERVER_URL,
    };
  },
  methods: {
    contentLimits() {
      if (window.innerWidth > 1000) {
        this.contentLimit = 825;
      } else if (window.innerWidth > 767 && window.innerWidth < 1001) {
        this.contentLimit = 350;
      } else {
        this.contentLimit = 350;
      }
    },
    isQuestionTooLong() {
      if (this.discussion.question && (this.discussion.question.length > this.contentLimit)) {
        this.isQuestionShrinked = true;
      }
    },
    isAnswerTooLong() {
      if (this.discussion.response && (this.discussion.response.length > this.contentLimit)) {
        this.isAnswerShrinked = true;
      }
    },
  },
  filters: {
    shortContent: filters.shortContent,
  },
  created() {
    this.contentLimits();
    this.isQuestionTooLong();
    this.isAnswerTooLong();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.section--discussion {
  background-color: $color--gray-4;
  padding: 50px 0;
}
.question{
  padding: 63px 0 20px;
  background-color: $color--orange;
  position: relative;
  &--response{
    background-color: $color--navy-blue;
  }
  @include media('<lg') {
    padding: 50px 90px 25px;
  }
  @include media('<md') {
    padding: 13px 30px 35px;
  }
  &__avatar {
    background-color: $color--gray-4;
    border-radius: 50%;
    height: 67px;
    width: 67px;
    position: absolute;
    left: -83px;
    top: -20px;
    @include media('<lg') {
      position: relative;
      left: 0;
      top: 0;
      margin-right: 20px;
    }
    @include media('<md') {
      height: 48px;
      width: 48px;
    }
  }
  &__username {
    font-size: 20px;
    font-weight: bold;
    padding-right: 20px;
    @include media('<md') {
      font-size: 14px;
      padding-right: 5px;
    }
  }
  &__content {
    font-size: 16px;
    line-height: 19px;
    margin: 38px 0 0 0;
    overflow: hidden;
    color: $color--white;
    margin-bottom: 30px;
    @include media('<md') {
      font-size: 14px;
    }
  }
  &__header {
    @include media('<lg') {
      display: flex;
      align-items: center;
    }
  }
  &__button {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 800;
    border: none;
    margin-top: 0;
    &:hover {
      background-color: transparent;
      color: $color--white;
      box-shadow: none;
    }
    @include media('<md') {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AskScientist/Discussion.vue